import { apiClient } from './client';

export const login = (email: string, password: string, turnstileToken?: string) =>
  apiClient.post('/api/auth/login', { email, password, cfTurnstileToken: turnstileToken });

export const me = () =>
  apiClient.get('/api/auth/me');

export const logoutRequest = () =>
  apiClient.post('/api/auth/logout');
